export const incomeBracketsOptions = [
  { key: '1', text: 'Sem Renda', value: '1' },
  { key: '2', text: 'Até R$2.500,00', value: '2' },
  { key: '3', text: 'De R$2.500,01 a R$5.000,00', value: '3' },
  { key: '4', text: 'De R$5.000,01 a R$10.000,00', value: '4' },
  { key: '5', text: 'Acima de R$10.000,01', value: '5' },
  { key: '6', text: 'Não desejo informar', value: '6' }
];
